module.exports = __webpack_public_path__ + "img/111.0697eeb4.jpg";